var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEtEthiopia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_18115)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.584 0.308472H-15.8898V44.1947H75.584V0.308472Z",
    fill: "#FFC621"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.7598 30.1829H-15.8286V45.12H75.7598V30.1829Z",
    fill: "#EF2118"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.584 0H-15.8898V15.8625H75.584V0Z",
    fill: "#298C08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4626 32.8229C26.2141 32.8229 21.9594 28.5681 21.9594 23.3196C21.9594 18.0711 26.2141 13.8164 31.4626 13.8164C36.7111 13.8164 40.9658 18.0711 40.9658 23.3196C40.9658 28.5681 36.7111 32.8229 31.4626 32.8229Z",
    fill: "#006BC6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.7242 16.5851L36.297 16.9817L34.2261 19.8898L33.6709 19.5373L35.733 16.5851H35.7242ZM33.1334 23.4589L33.9882 22.8596L33.6357 21.7404L37.8745 21.8021L39.1082 20.8592L33.3184 20.7975L32.2433 17.5457L31.6617 18.8675L33.1334 23.45V23.4589ZM26.3918 17.2284L26.947 16.8054L29.0884 19.6607L28.5949 20.0749L26.3918 17.2284ZM32.1552 21.7669L31.8467 20.7799H30.6747L32.0142 16.7437L31.4854 15.2897L29.6789 20.7887L26.2596 20.8327L27.3347 21.7757L32.1552 21.758V21.7669ZM24.171 26.2789L23.9331 25.6267L27.3083 24.4547L27.555 25.0715L24.171 26.2789ZM30.2605 22.1899L29.2294 22.181L28.8681 23.2914L25.4489 20.7799L23.8979 20.8327L28.5773 24.2432L27.5639 27.5214L28.7976 26.7812L30.2605 22.1899ZM32.0054 31.1786L31.3092 31.1962L31.2827 27.6272L31.9349 27.5831L32.0054 31.1874V31.1786ZM30.0666 24.1022L29.7317 25.0804L30.6747 25.7854L27.2025 28.2264L26.7619 29.7069L31.4854 26.3582L34.2614 28.3586L33.9529 26.9486L30.0754 24.1022H30.0666ZM39.1699 25.2478L38.9672 25.9087L35.5568 24.8336L35.733 24.1991L39.1699 25.2478ZM31.8379 24.8953L32.6663 25.521L33.618 24.8424L34.8694 28.8962L36.1384 29.7774L34.42 24.252L37.1871 22.2251L35.7507 22.0841L31.8379 24.8953Z",
    fill: "#FFC621"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_18115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEtEthiopia);
export default __webpack_public_path__ + "static/media/et Ethiopia.44440b6aae868bb5aeffe67b9ba8b17d.svg";
export { ForwardRef as ReactComponent };